@if (person) {
  <div class='person-page'>
    @if (operation == 'Invite') {
      <div > <invite-list [from]="person.primaryEmail" [canAll]=false ></invite-list></div>
    }
    @if (operation == 'Family') {
      <div > <relation-list [from]="person" [canAll]=false [name]="fromName" (notifyParent)="relateSubmittedHandler($event)"></relation-list></div>
    }
    @if (operation == 'Activity') {
      <div > <activity-list [from]="person._key" [canAll]=false></activity-list></div>
    }
    @if (operation == 'Edit') {
      <div ><profile-form [person]="person" (notifyParent)="personSubmittedHandler($event)"></profile-form></div>
    }
    @if (operation == 'Pearl') {
      <div ><seen-pearl-list [email]="email"></seen-pearl-list></div>
    }
    @if (operation == 'Subscriptions') {
      <div > <subscription-list [from]="person" [canAll]=false></subscription-list></div>
    }
    @if (operation == 'Groups') {
      <div > <group-list [from]="person._key" [canAll]=false></group-list></div>
    }
    <!-- <div *ngIf="operation == 'Orders'" > <order-list [customers]="" [from]="person.primaryEmail" [canAll]=false></order-list></div> -->
  </div>
}
